import { useDragAndDrop } from '#hooks/use-drag-and-drop.js';
import { useMemo } from 'react';

export function usePlaceDragAndDrop({ location, placeType, movePlace }) {
    const {
        draggedItemId: draggedPlaceId,
        onDragStart,
        onDragEnd,
        onDragCancel,
        sensors
    } = useDragAndDrop({
        onDragEnd: (active, over) => {
            const from = active.data.current.sortable.index;
            const to = over.data.current.sortable.index;

            switch (true) {
                case !over || active.id === over.id:
                    break;
                case from >= 0 && to >= 0: {
                    movePlace(location.name, placeType, from, to);
                    break;
                }
            }
        }
    });

    const ids = useMemo(() => location[`${placeType}`].map((o) => o.id), [location]) ?? [];
    const draggedPlace = location?.[`${placeType}`].find((el) => el.id === draggedPlaceId);

    return {
        sensors,
        ids,
        draggedPlace,
        onDragStart,
        onDragEnd,
        onDragCancel
    };
}
